import { render, staticRenderFns } from "./modal-score-teacher.vue?vue&type=template&id=63e5f590&"
import script from "./modal-score-teacher.vue?vue&type=script&lang=js&"
export * from "./modal-score-teacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports